import React, { useRef, useState } from "react";
import "./FileUploadProgressBar.scss";
import ProgressBar from "@ramonak/react-progress-bar";
import { AlertCircle, CheckCircle, RotateCw, X } from "react-feather";
import csvIcon from "../../../assets/resource_icon/csv.svg";

const FileUploadProgressBar = (props: any) => {
  const {
    progress,
    themeState,
    fileUploadError,
    file,
    progressRef,
    SetFileUpladError,
  } = props;

  const hideProgress = () => {
    SetFileUpladError({});
    progressRef.current.style.display = "none";
  };

  return (
    <div ref={progressRef}>
      <div className="file__upload__progress__section__wrapper ">
        <div className="icon__section">
          <img src={csvIcon} alt="" />
        </div>
        <div className="info__section__wrapper">
          <div className="row__section">
            <span className="file__name">
              {file.name}
              <span className="file__size">
                {" "}
                {(file.size / 1024).toFixed(2)} Kb
              </span>
            </span>

            <div className="file__controls">
              {/* {progress === 100 && <RotateCw className="reupload__icon" />} */}
              {progress === 100 && (
                <X className="cancel__icon" onClick={hideProgress} />
              )}
            </div>
          </div>
          <div className="test">
            <ProgressBar
              completed={progress}
              height="3px"
              customLabel="."
              baseBgColor={
                fileUploadError?.existing_users
                  ? "rgba(240, 68, 56, 0.2)"
                  : "var( --primary-progress-bar-bg)"
              }
              bgColor={
                fileUploadError?.existing_users
                  ? "#F04438"
                  : "var( --secondary-progress-bar-bg)"
              }
              labelSize="0"
            />
          </div>

          <span className="percentage__uploaded"> {progress}% done</span>
        </div>
      </div>

      {fileUploadError && (
        <div className="file__upload__error__wrapper">
          <div className="file__upload__error__container">
            {fileUploadError?.existing_users?.map((err: string) => {
              return (
                <div
                  key={err}
                  className={`file__upload__error ${
                    fileUploadError && "error__color"
                  }`}
                >
                  <div className="error__icon ">
                    <AlertCircle />
                  </div>
                  <span>
                    An account with email address “{err}” already exists.
                  </span>
                </div>
              );
            })}

            {fileUploadError?.created_users?.map((user: string) => {
              return (
                <div key={user} className="file__upload__error created__user">
                  <div className="check__icon ">
                    <CheckCircle />
                  </div>
                  <span className="created__message">
                    An account with email address “{user}” added successfully.
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default FileUploadProgressBar;
